import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'detach_department_permission_tags';
export const useDetachDepartmentPermissionTagsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    toast_success: 'Теги доступа успешно откреплены',
    toast_error: 'Не удалось открепить теги доступа',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_success: 'Permission tags successfully detached',
    toast_error: 'Failed to detach permission tags',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_success: 'Tags de permissão desvinculadas com sucesso',
    toast_error: 'Falha ao desvincular tags de permissão',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_success: 'Etiquetas de permisos desvinculadas con éxito',
    toast_error: 'No se pudieron desvincular las etiquetas de permisos',
  },
}) as Record<string, unknown>;
